module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('h4', [_vm._v("Please select the category that best describes your issue.")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "component-fade",
      "appear": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "type",
    attrs: {
      "dark": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.typeClicked('Plumbing')
      }
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/water.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Plumbing")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "type",
    attrs: {
      "dark": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.typeClicked('Heating')
      }
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/heating.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Heating")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "type",
    attrs: {
      "dark": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.typeClicked('Electric')
      }
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/electric.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Electric")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "type",
    attrs: {
      "dark": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.typeClicked('Appliances')
      }
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/appliances.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Appliances")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "type",
    attrs: {
      "dark": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.typeClicked('Exterior')
      }
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/exterior.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Exterior")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "type",
    attrs: {
      "dark": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.typeClicked('Interior')
      }
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/interior.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Interior")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ecd3269","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/IssueType.vue
// module id = 358
// module chunks = 4